import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  root: {},
  playButton: {
    '&.MuiButton-root': {
      fontWeight: 'bold',
      textTransform: 'none',
    },
  },

  joinActions: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    width: '100%',
  },

  fullTeamsText: {
    color: theme.palette.error.light,
    marginBottom: theme.spacing(1.875),
  },
}));
